import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getFaqList() {
        const response = await service.get(`${getApiBaseUrl()}solution/faq`);
        return response;
    },

    async getFaq(id) {
        const response = await service.get(
            `${getApiBaseUrl()}solution/faq/${id}`
        );
        return response;
    },

    async addFaq(faq) {
        const response = await service.post(`${getApiBaseUrl()}solution`, faq);
        return response;
    },

    async updateFaq(faq) {
        const response = await service.patch(
            `${getApiBaseUrl()}solution/faq`,
            faq
        );
        return response;
    },

    async deleteFaq(faq_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}faq/${faq_id}`
        );
        return response;
    },
};
